import moment from "moment";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { aiAttributionItems } from "@/helpers/commonHelper";

export default {
  name: "EventProcessingStatus",
  components: { LogOverview },
  data: () => ({ shownLog: null, aiAttributionItems }),
  props: [
    "editedEvent",
    "step",
    "position",
    "users",
    "isAdmin",
    "isOwnedBySubPrincipal"
  ],
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    autocompleteFilter(item, queryText) {
      return (
        item.first_name
          .toLocaleLowerCase()
          .includes(queryText.toLocaleLowerCase()) ||
        item.last_name.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    }
  },
  computed: {
    eventAiAttribution: {
      get() {
        return this.editedEvent?.ai_attribution ?? "";
      },
      set(value) {
        this.$set(this.editedEvent, "ai_attribution", value ?? "");
      }
    },
    owner() {
      if (!this.editedEvent._id) {
        const user = this.$store.state.currentUser;
        if (user?.first_name && user?.last_name)
          return `${user.first_name} ${user.last_name}`;
        else return null;
      }
      const user = this.users.find(u => u.id === this.editedEvent.owner_id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    changer() {
      if (!this.editedEvent._id) {
        const user = this.$store.state.currentUser;
        if (user?.first_name && user?.last_name)
          return `${user.first_name} ${user.last_name}`;
        else return null;
      }
      const user = this.users.find(
        u =>
          u.id === this.editedEvent.updated_by ||
          u._id === this.editedEvent.updated_by
      );
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    logUrl() {
      return `${env.events_api_client_url}log/${this.editedEvent._id}`;
    }
  }
};
